export function setCookie(name, value, options = {}) {
  if (typeof document === 'undefined') return

  let cookieStr = `${name}=${value};`

  for (const [key, val] of Object.entries(options)) {
    cookieStr += val === '' ? `${key};` : `${key}=${val};`
  }

  document.cookie = cookieStr
}
